import { Middleware } from '@reduxjs/toolkit';
import { RootState } from '@/redux/store';
import { showEmailConfirmationToast } from '@/helpers';
import {
  restrictedActionsIfUserIsBlocked,
  emailConfirmationActions,
} from './config';

const createUserAccessMiddleware =
  (): Middleware<object, RootState> => (store) => (next) => (action) => {
    const state = store.getState();

    const isUserBlocked = state.user.data?.isLocked;

    const isRestrictedAction = restrictedActionsIfUserIsBlocked.has(
      action.type,
    );

    if (isUserBlocked) {
      if (isRestrictedAction) {
        return state;
      }

      return next(action);
    }

    const isEmailConfirmationRequired = emailConfirmationActions.has(
      action.type,
    );

    if (isEmailConfirmationRequired) {
      const isEmailConfirmed = state.user.data?.emailStatus === 'confirmed';

      if (isEmailConfirmed) {
        return next(action);
      }

      showEmailConfirmationToast();
      return state;
    }

    return next(action);
  };

export default createUserAccessMiddleware;
